import './PrivatePageBanner.scss';

export { default } from './PrivatePageBanner';
